import { CSSProperties, SyntheticEvent } from 'react';
import { useBankLogo } from '../../hooks/useBankLogo';
import { useAppSelector } from '../../app/hooks';
import { selectConfiguration } from '../../app/slices/configuration.slice';
// @ts-ignore
import generic from '../../assets/bank-logos/generic.png';

interface BankLogoProps {
	bankName: string;
	bankLogo?: string;
	style?: CSSProperties;
}

const BankLogo = ({ bankName, style, bankLogo }: BankLogoProps) => {
	const vendor = useAppSelector(selectConfiguration).bankIntegrationVendor;
	if (vendor === 'FINCREDIBLE') {
		return <FincredibleBankLogo style={style} bankName={bankName} bankLogo={bankLogo} />;
	}

	return <KlarnaBankLogo style={style} bankName={bankName} />;
};

const FincredibleBankLogo = ({ bankName, bankLogo, style }: BankLogoProps) => {
	const id = `${bankName}-logo`;
	const alt = `${bankName} logo`;
	return (
		<img
			id={id}
			className="bank-logo"
			alt={alt}
			onError={onImageLoadError}
			src={bankLogo || bankName}
			style={{ width: '100%', height: '100%', borderRadius: '50%', ...style }}
		/>
	);
};

const KlarnaBankLogo = ({ bankName, style }: BankLogoProps) => {
	const src = useBankLogo(bankName);
	const id = `${bankName}-logo`;
	const alt = `${bankName} logo`;
	return (
		<img
			id={id}
			className="bank-logo"
			alt={alt}
			src={src}
			style={{ width: '100%', height: '100%', borderRadius: '50%', ...style }}
		/>
	);
};

function onImageLoadError(e: SyntheticEvent<HTMLImageElement>) {
	e.currentTarget.src = generic;
}

export default BankLogo;
